<template>
  <v-tour name="tour" :steps="steps" :options="options" :callbacks="callbacks">
  </v-tour>
</template>

<script>
export default {
  name: "ProjectsTourComponent",
  data() {
    return {
      callbacks: {
        onSkip: this.tourStepFinish,
        onFinish: this.tourStepFinish
      },
      options: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: "Cerrar",
          buttonPrevious: "Anterior",
          buttonNext: "Continuar",
          buttonStop: "Finalizar"
        }
      },
      steps: [
        {
          target: "#app",
          content: `
            <h5>Paso 1 de 4</h5>
            <h6>Agrupa tu trabajo por proyecto</h6>
            <p>Crea un proyecto por cliente, obra o servicio. Asocia facturas y gastos para ver cuánto te deja realmente.</p>
          `
        },
        {
          target: "#app",
          content: `
            <h5>Paso 2 de 4</h5>
            <h6>Mide rentabilidad en tiempo real</h6>
            <p>Las tarjetas de resumen muestran ingresos, gastos y utilidad de todos tus proyectos activos en un solo vistazo.</p>
          `
        },
        {
          target: "#app",
          content: `
            <h5>Paso 3 de 4</h5>
            <h6>Controla cobros y pagos</h6>
            <p>Registra abonos parciales, marca pagos a proveedores y mira cuánto te falta cobrar o pagar por proyecto.</p>
          `
        },
        {
          target: "#app",
          content: `
            <h5>Paso 4 de 4</h5>
            <h6>Toma decisiones con datos</h6>
            <p>Identifica qué proyectos son más rentables y enfoca tus esfuerzos donde realmente generan margen.</p>
          `
        }
      ]
    };
  },
  methods: {
    tourStepFinish() {
      const userConfigGeneral = {
        is_projects_tour_completed: 1
      };
      this.$store.dispatch("userConfigGeneralUpdated", userConfigGeneral);
    }
  },
  mounted() {
    this.$tours["tour"].start();
  }
};
</script>

<style lang="scss" scoped></style>
